import { SolicitudVoleoDetail } from "@/services/voleo-requests.service";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  detail: SolicitudVoleoDetail | null;
  isRejected: boolean;
}

export const VoleoRequestNotes = ({ detail, isRejected }: Props) => {
  return (
    <>
      <Flex flexDir="column" gap="12px">
        <Flex alignItems="center" gap="30px">
          <Text fontWeight={700}>Observaciones</Text>
        </Flex>

        <Flex
          flexDir="column"
          padding="12px"
          height="120px"
          overflowY="auto"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
          gap="12px"
        >
          <Text fontSize="14px">{String(detail?.observaciones ?? "").trim() || "-"}</Text>
        </Flex>
      </Flex>

      {isRejected && (
        <Flex flexDir="column" gap="12px">
          <Flex alignItems="center" gap="30px">
            <Text fontWeight={700}>Motivo de rechazo</Text>
          </Flex>

          <Flex
            flexDir="column"
            paddingX="24px"
            borderLeft={`4px solid ${AppColors.WHITE_BORDER_1}`}
          >
            <Text fontWeight={400} fontSize="14px">
              {detail?.motivoRechazo ?? "-"}
            </Text>
            <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
              {detail?.fechaRechazo
                ? dayjs
                    .utc(detail.fechaRechazo)
                    .tz("America/Argentina/Buenos_Aires")
                    .format("DD/MM/YYYY - HH:mm")
                : "-"}{" "}
              - {detail?.usuarioRechazo ?? "-"}
            </Text>
          </Flex>
        </Flex>
      )}
    </>
  );
};
